const apiFiles = require.context('./', true, /-api.js$/)

const apis={}
apiFiles.keys().forEach(key => {
  const apiFile=apiFiles(key).default
  apis[apiFile.name]=apiFile
})
export default {
  name:"commonApi",
  ...apis
}



// WEBPACK FOOTER //
// ./src/api/common/apis.js